export const CATEGORY_OPTIONS = [
  { label: "Gym & Fitness", value: "gym" },
  { label: "Yoga & Mindfulness", value: "yoga" },
  { label: "Kickfit & Cardio Boxing", value: "boxing" },
  { label: "Pilates & Core Training", value: "pilates" },
  { label: "Nutrition & Lifestyle", value: "nutrition" },
  { label: "Rehab & Stretching", value: "recovery" },
  { label: "Sports Training", value: "sports" },
] as const;
